import * as api from "api"
import BookIcon from "common/icons/VehicleCatalogs/BookIcon"
import CatalogeIcon from "common/icons/VehicleCatalogs/CatalogeIcon"
import { memo } from "react"

type VehicleCatalogsTypesMap = {
  [type in api.VehicleCatalogsTypes]: JSX.Element
}

export const vehicleCatalogsTypesMap: VehicleCatalogsTypesMap = {
  Pdf: <BookIcon />,
  Catalogue: <CatalogeIcon />,
  Book: <BookIcon />,
}

type VehicleCatalogsIconProps = { type: api.VehicleCatalogsTypes }

const VehicleCatalogsIcon = ({ type }: VehicleCatalogsIconProps) => {
  return vehicleCatalogsTypesMap[type]
}

export default memo(VehicleCatalogsIcon)
